import { call, all, select, takeLatest } from 'redux-saga/effects';
import { fetchFiltered as fetchFilteredContract } from '../insuranceContracts/sagas';
import * as contractActions from '../insuranceContracts/actions';
import { fetchFiltered as fetchFilteredDevice } from '../insuredDevices/sagas';
import * as deviceActions from '../insuredDevices/actions';
import { fetchFiltered as fetchFilteredPurchases } from 'billing/purchases/sagas';
import * as purchaseActions from 'billing/purchases/actions';
import * as selectors from 'reducers';
import * as types from './types';

export function* fetchData({ payload }) {
  const { subscription, att_subscription, quick_subscription, userId } = payload;

  yield call(fetchFilteredContract, contractActions.fetchFiltered({ subscription, att_subscription, quick_subscription }) );

  const contractFilter = subscription
    ? { subscription }
    : att_subscription
      ? { attSubscription: att_subscription }
      : { quickSubscription: quick_subscription };

  const contracts = yield select(selectors.getFilteredInsuranceContracts, contractFilter);
  const pendingContract = contracts.find(contract => contract.status === 'pending');
  
  if (pendingContract) {
    yield call(fetchFilteredDevice, deviceActions.fetchFiltered({ contract: pendingContract.id, status: ['active', 'pending'] }) );

    const devices = yield select(selectors.getFilteredInsuredDevices, pendingContract.id);
    const activeDevice = devices.find(device => device.status === 'active');

    if (activeDevice && activeDevice.activation_lineitem) {
      yield call(fetchFilteredPurchases, purchaseActions.fetchFiltered(userId, { lineitem: activeDevice.activation_lineitem }) );
    }
  }
}
  

export function* watchFetchData() {
  yield takeLatest(types.FETCH_DATA, fetchData);
}

export function* watchInsuranceLink() {
  yield all([
    call(watchFetchData),
  ]);
}
